/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';
import { User } from '../../models/user';

export interface UserPost$Params {
  practiceId: string | null;
  isnoehruser?: boolean;
      body: User
}

export function userPost(http: HttpClient, rootUrl: string, params: UserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, userPost.PATH, 'post');
  if (params) {
    rb.path('practiceId', params.practiceId, {});
    rb.query('isnoehruser', params.isnoehruser, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

userPost.PATH = '/api/practices/{practiceId}/users';
